import { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import produce from "immer";
import Label from "../../refresh/Label";
import { useMediaSelector } from "../../refresh/selectors/MediaSelector";
import RedButton from "../../refresh/RedButton";
import SidebarLightbox from "../../refresh/SidebarLightbox";
import TextArea from "../../refresh/inputs/TextArea";
import GenericOptions from "../GenericOptions";
import styles from "./sharedStyles";
import Checkbox from "../../refresh/inputs/Checkbox";

const useStyles = createUseStyles({
  ...styles,
});

const EditExternalHotspot = ({
  show,
  hotspot,
  onClose,
  onComplete,
  account,
  isLink,
  setLink,
  template = false,
}) => {
  const classes = useStyles();
  const [config, setConfig] = useState(hotspot);
  const [media, getMedia] = useMediaSelector({});

  useEffect(() => {
    if (media.id) {
      setConfig(
        produce(c => {
          delete c.options.url;
          c.options.clip = {
            id: media.id,
            name: media.title,
          };
        }),
      );
    }
    // trigger effect if media changes, we only need the id
    // to detect this. eslint disagrees but what do they know
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media.id]);

  return (
    <SidebarLightbox
      show={show}
      onClose={onClose}
      sidebar={
        <>
          <h1 className={classes.title}>
            Edit Audio {template ? "Template" : "Popup"}
          </h1>
          <p className={classes.subtitle}>Play some sound</p>
          <div className={classes.grow} />
          {!template && (
            <Checkbox sidebar value={isLink} onChange={setLink}>
              Show in Links menu
            </Checkbox>
          )}
        </>
      }
    >
      <div className={classes.options}>
        <GenericOptions
          icon="Audio"
          config={config}
          setConfig={setConfig}
          account={account}
          template={template}
        />
        <Label name="Audio clip" required>
          <div className={classes.genericSelector}>
            <p>
              {config.options?.clip?.name ||
                config.options?.url ||
                "Select an audio clip"}
            </p>
            <button onClick={() => getMedia([3])}>Select from CMS</button>
          </div>
        </Label>
        <TextArea
          optional
          label="transcript"
          value={config.options.content}
          onChange={content =>
            setConfig(
              produce(c => {
                c.options.content = content;
              }),
            )
          }
        />
        <RedButton
          disabled={
            !(
              config.tooltip &&
              config.options?.title &&
              (config.options?.url || config.options?.clip)
            )
          }
          onClick={() => onComplete(config)}
        >
          Save
        </RedButton>
      </div>
    </SidebarLightbox>
  );
};

export default EditExternalHotspot;
